// src/hooks/useTransactions.ts
import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@/lib/queryClient";
import { TransactionItem } from "@/types/transactions";

export function useTransactions() {
  return useQuery<TransactionItem[]>({
    queryKey: ["/api/transactions/"],
    queryFn: async () => {
      const res = await apiRequest("GET", "/api/transactions/");
      if (!res.ok) {
        if (res.status === 404) return [];
        throw new Error(await res.text());
      }
      return res.json();
    },
    refetchInterval: 15000,
  });
}